<script setup lang="ts">
import BankTransactionAmount from '@/components/bank-transactions/display/BankTransactionAmount.vue'
import CheckField from '@/components/fields/CheckField.vue'
import { reformatDateString } from '@/helpers/dates'

interface Props {
  /** The bank transaction to display */
  transaction: BankTransactionResource
}

defineProps<Props>()

defineOptions({
  name: 'UnassignedBankTransaction',
  inheritAttrs: false
})
</script>

<template>
  <tr class="text-xs md:text-sm">
    <td class="py-2 md:py-3">
      <CheckField :label="transaction.name" v-bind="$attrs" />
    </td>

    <td class="hidden p-3 md:table-cell">
      {{ reformatDateString(transaction.execution_date) }}
    </td>
    <td class="hidden p-3 md:table-cell">
      <p class="font-primary font-medium break-all">{{ transaction.name }}</p>
    </td>

    <td class="table-cell p-2 md:hidden" colpsan="2">
      <p class="font-primary font-medium break-all">{{ transaction.name }}</p>
      {{ reformatDateString(transaction.execution_date) }}
    </td>

    <td class="py-2 text-right whitespace-nowrap md:py-3">
      <div class="flex flex-col items-end">
        <BankTransactionAmount :transaction />
      </div>
    </td>
  </tr>
</template>

<style lang="scss" scoped>
@reference "../styles/main.css";

td {
  @apply border-b border-secondary-300;
}
</style>
